import{jsx as o,jsxs as e,Fragment as i}from"react/jsx-runtime";import d from"@atlaskit/spinner";import r from"@atlaskit/tooltip";import{useState as l,useCallback as n,useEffect as t}from"react";import s from"styled-components";import a from"./ItemContent.js";import{Info as c,SpinnerContainer as u}from"./styled.js";const p=s.div`
	position: relative;

	width: 200px;
	height: ${({hasFirstField:o,hasSecondField:e})=>o&&e?"165px":o||e?"150px":"135px"};
	box-sizing: border-box;
	padding: 20px;

	background-color: ${({isGrayed:o,grayedBackgroundColor:e,backgroundColor:i})=>o?e||"#f1f2f4":i};
	border-radius: ${({borderRadius:o})=>`${o}px`};
	box-shadow: ${({boxShadow:o})=>o};
	border: ${({isSelected:o})=>"1px solid "+(o?"#4C9AFF":"transparent")};

	display: flex;
	align-items: center;
	flex-direction: column;
	row-gap: 8px;

	transition: background-color 100ms linear;

	.delete-action {
		opacity: 0;
		transition: opacity 100ms linear;
	}

	&:hover {
		.delete-action {
			opacity: 1;
		}
	}
`;function f({node:s,userInfo:f,selectedUser:m,isLoading:h,getUserValueFromField:v,additionalProps:b,darkTheme:g,children:x}){const[F,y]=l(""),[k,C]=l(""),{viewOptions:S,userRecords:w,fields:I,shouldCheckCosmosLicense:j,isCosmosInstalled:$,onItemClick:G}=b||{},{borderRadius:R,titleFieldId:O,footerFieldId:B,color:V}=S||{},A=!j||!!$,E=n((o=>{if(!A||!o||!(null==s?void 0:s.id))return"";const e=null==w?void 0:w.find((o=>o.accountId===s.id));if(!e)return"";return(null==I?void 0:I.find((e=>e.id===o||e.value===o)))?v(null==e?void 0:e.values,I,o):""}),[null==s?void 0:s.id,I,w,A]);return t((()=>((null==s?void 0:s.id)&&(y(E(O)),C(E(B))),()=>{y(""),C("")})),[null==s?void 0:s.id,E,O,B]),(null==f?void 0:f.error)?o(p,Object.assign({isGrayed:!1,hasFirstField:!1,hasSecondField:!1,borderRadius:R||3,isSelected:!1},{children:o(c,{children:"Failed to load user."})})):o(r,Object.assign({content:(null==s?void 0:s.isGrayed)?"Not in filter":""},{children:e(p,Object.assign({isGrayed:!!(null==s?void 0:s.isGrayed),hasFirstField:!!O,hasSecondField:!!B,borderRadius:R||3,isSelected:(null==m?void 0:m.id)===(null==f?void 0:f.key),backgroundColor:null==g?void 0:g.backgroundColor,grayedBackgroundColor:(null==g?void 0:g.grayedBackgroundColor)||"#f1f2f4",boxShadow:null==g?void 0:g.boxShadow,style:{cursor:G?"pointer":"default"},onClick:()=>{G&&G(null==s?void 0:s.id)}},{children:[h?o(u,{children:o(d,{})}):o(a,{viewType:"card",userInfo:f,color:V||"#4C9AFF",firstElementValue:F,secondElementValue:k}),x||o(i,{})]}))}))}export{f as default};
